import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

/** Get empty slate content (an empty paragraph). */
export const createEmptyContent = () => [createParagraph()];
